import { getElementById } from "../util/Utils";
import { any } from "../util/Reductions";

const ToggleNames = [
  "DUMMY",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_EXPERIMENT",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_TRACKING",
  "HEUREKA_1913_MIGRATE_TO_OC_SHEET",
  "HEUREKA_2047_NEXT_BEST_FACET",
  "HEUREKA_2047_NEXT_BEST_FACET_E3792",
  "HEUREKA_2122_SHEET_MEHR_ANZEIGEN_WIRD_ALLE",
  "HEUREKA_2167_MIGRATE_FILTER_BANNER_TO_SVELTE",
  "HEUREKA_2167_MIGRATE_DESKTOP_SORTING_TO_SVELTE",
  "HEUREKA_2178_FILTER_SECTION_IS_NOT_LOADED",
  "HEUREKA_1975_OC_CHIP_MIGRATION",
  "HEUREKA_1975_OC_COMPONENTS_MIGRATION",
  "HEUREKA_1975_REFACTOR_TRACKING",
  "HEUREKA_2217_MIGRATE_TO_OC_LINK",
  "HEUREKA_2219_MIGRATE_TO_OC_BUTTON",
  "HEUREKA_2221_MIGRATE_TO_OC_BANNER",
  "HEUREKA_2276_STATELESS_TRACKING_CHANGE",
  "HEUREKA_2276_STATELESS_TRACKING_SUBMIT",
  "HEUREKA_2320_NO_HORIZONTAL_SCROLLING_FOR_DIMENSION_FACETS",
  "HEUREKA_2321_FILTERBAR_V2",
  "HEUREKA_2321_FILTERBAR_V2_E3911",
  "HEUREKA_2387_FIX_WRONG_SELECTED_SORTING_OPTION",
] as const;

export type ToggleName = (typeof ToggleNames)[number];
export type ToggleStates = Record<ToggleName, boolean>;

let toggles: ToggleStates;

function asBoolean(value?: string): boolean {
  return "true" === value;
}

export function initToggles() {
  const data = getElementById("leafcutter_toggles")?.dataset;
  const state = data
    ? (toggleName: ToggleName) => asBoolean(data[toggleName] || data[toggleName.toLowerCase()])
    : () => false;
  toggles = ToggleNames.reduce((htmlToggles, toggleName) => {
    htmlToggles[toggleName] = state(toggleName);
    return htmlToggles;
  }, {} as Partial<ToggleStates>) as ToggleStates;
}

/**
 *
 */
export function updateToggle(toggle: ToggleName, state: boolean) {
  if (!toggles) {
    toggles = {} as ToggleStates;
  }
  toggles[toggle] = state;
}

export function isActive(toggle: ToggleName) {
  return toggles[toggle];
}

export function isNotActive(toggle: ToggleName) {
  return !isActive(toggle);
}

export function isAnyActive(...toggles: ToggleName[]) {
  return toggles.map(isActive).reduce(any, false);
}
